import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import type { VideoEncontrado } from "../lib/video";

// youtube-nocookie: sem cookies de rastreio antes do play.
const playerYoutube = (id: string) =>
  `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;

// Os vídeos do Tella da central não têm áudio: tocam sozinhos, mudos e em loop, como um GIF.
// O autoplay do Tella é `autoPlay=true`; o `a=1` que vem nos artigos só toca a prévia de
// fundo (5 s borrados) e deixa o vídeo principal parado esperando clique. E o mudo precisa
// ser `muted=1`: com `muted=true` o vídeo começa com som, e o navegador bloqueia autoplay
// com som dentro de outro site (o player ficava parado).
const playerTella = (id: string) =>
  `https://www.tella.tv/video/${id}/embed?autoPlay=true&muted=1&loop=true&b=0&title=0&wt=0`;

const VideoArtigo: React.FC<{ video: VideoEncontrado }> = ({ video }) => {
  const { t } = useTranslation();
  const [tocando, setTocando] = useState(false);
  const titulo = video.titulo ? t("video_do_artigo", { titulo: video.titulo }) : t("video_relacionado");

  return (
    <div className="video-artigo">
      <p className="artigos-titulo">{titulo}</p>
      <div className={`video-artigo-quadro video-${video.plataforma}`}>
        {video.plataforma === "tella" ? (
          // loading="lazy": só carrega quando chega perto da tela, então vídeos antigos da
          // conversa não ficam todos tocando ao mesmo tempo.
          <iframe
            src={playerTella(video.id)}
            title={titulo}
            loading="lazy"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        ) : tocando ? (
          <iframe
            src={playerYoutube(video.id)}
            title={titulo}
            allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
            allowFullScreen
          />
        ) : (
          // YouTube tem áudio: mostra a capa e só carrega o player (~1 MB) no clique.
          <button type="button" onClick={() => setTocando(true)} aria-label={t("assistir_video")}>
            <img src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`} alt="" loading="lazy" />
            <span className="video-artigo-play" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
};

export default VideoArtigo;
